import { render, staticRenderFns } from "./StampCode.vue?vue&type=template&id=ebafe13a&scoped=true&"
import script from "./StampCode.vue?vue&type=script&lang=js&"
export * from "./StampCode.vue?vue&type=script&lang=js&"
import style0 from "./StampCode.vue?vue&type=style&index=0&id=ebafe13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebafe13a",
  null
  
)

export default component.exports